/* eslint-disable @typescript-eslint/no-explicit-any */
export default {
  install: function (Vue: any): void {
    Vue.prototype.$window = global.window;
  }
};
